module.exports = __webpack_public_path__ + "static/img/13.d42acee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/13.png
// module id = TmPi
// module chunks = 0